<div class="label">
  <app-text [textSize]="TextSize.alert" [textType]="TextType.base" [text]="text"></app-text>
</div>
